// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3K704","dragIcon":"Choice_dragIcon__1W-wq","left":"Choice_left__2zds7","input":"Choice_input__DxqWb"};